const {message_errors} = require('../utils/contains');

$(document).ready(function () {
    let code_search = {
        2: '1100000',
        3: '1010000',
        5: '1001100',
        6: '1001010',
        7: '0000001'
    };

    let data_tree = {
        lv1: 0,
        lv2: 0,
        lv3: 0,
        lv4: 0,
        lv5: 0,
        lv6: 0,
        lv7: 0,
    };
    window.data_tree = data_tree;

    $("#seminar-search").click(function (event) {
        $("#wrapSearchBox").show();
        event.stopPropagation();
        $('body').append(`<div id="wrap-search-box"></div>`);
    });

    $("#closeSearch").click(function () {
        $("#wrapSearchBox").hide();
        $("#wrap-search-box").remove();
    });

    $("#datepicker1").datepicker();
    $("#datepicker2").datepicker();

    $(window).click(function () {
        $("#wrapSearchBox").hide();
        $("#wrap-search-box").remove();
    });

    $("#wrapSearchBox").click(function (event) {
        event.stopPropagation();
    });

    $("input[name=datepicker1]").on("change", function () {
        $("#error-start-date").remove();
    });

    $("input[name=datepicker2]").on("change", function () {
        $("#error-end-date").remove();
    });

    const obj_tree = {
        lv1: ["lv2", "lv3", "lv4", "lv5", "lv6"],
        lv4: ["lv5", "lv6"],
    };

    function getDataSeminarClassTree() {
        $('input:checkbox').each(function () {
            let lv = $(this).attr("id")
            data_tree[lv] = this.checked ? 1 : 0;
        });
        const isChild1 = obj_tree.lv1.some(ele => data_tree[ele] === 1);
        data_tree.lv1 = isChild1 ? 1 : 0;

        const isChild4 = obj_tree.lv4.some(ele => data_tree[ele] === 1);
        data_tree.lv4 = isChild4 ? 1 : 0;
        const code = Object.values(data_tree).join("");
        if (code === "0000000") {
            return null
        }
        if (code === "1111111") {
            return null
        }
        if (code === "1111110") {
            return "1111110";
        }
        let arr = [code];
        code.split("").forEach((ele, index) => {
            if (ele === "1" && code_search[index + 1]) {
                arr.push(code_search[index + 1]);
            }
        })
        if (code === "1011110" || code === "1101110") {
            arr.push("1001110");
        }

        return arr;
    }

    $("#btn-search-seminar").click(function () {
        const start_date = $("#datepicker1").val();
        const end_date = $("#datepicker2").val();
        const name = $("#name").val();
        // validate start_date and end_date
        if (start_date && end_date) {
            if (moment(end_date).isBefore(start_date)) {
                $('#error-end-date').remove();
                $("#wrap-date-error").append(
                    `<span id="error-end-date" class="aino-error-form">${message_errors.END_DATE_GREATER_THAN_START_DATE}</span>`
                );
                return;
            }
        }
        // build data query
        let dataQuery = {
            start_date,
            end_date,
        };
        if (name) {
            dataQuery.name = name;
        }
        const data = getDataSeminarClassTree();
        if (data && data.length > 0) {
            dataQuery.seminar_code = data;
        }
        let url = updateQueryStringParameter(
            window.location.search,
            "start_date",
            dataQuery.start_date
        );
        url = updateQueryStringParameter(url, "end_date", dataQuery.end_date);
        url = updateQueryStringParameter(
            url,
            "seminar_code",
            dataQuery.seminar_code || ""
        );
        url = updateQueryStringParameter(url, "name", dataQuery.name || "");
        url = updateQueryStringParameter(url, "page", 1);
        $('.aino-loading').show();
        window.location.search = url;
    });

    function updateQueryStringParameter(uri, key, value) {
        let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        let separator = uri.indexOf("?") !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, "$1" + key + "=" + value + "$2");
        } else {
            return uri + separator + key + "=" + value;
        }
    }

    $('input[type="checkbox"]').change(function (e) {

        let checked = $(this).prop("checked");
        let container = $(this).parent();

        container.find('input[type="checkbox"]').prop({
            indeterminate: false,
            checked: checked
        });

        function checkSiblings(el) {
            let parent = el.parent().parent(),
                all = true;
            el.siblings().each(function () {
                let returnValue = all = ($(this).children('input[type="checkbox"]').prop("checked") === checked);
                return returnValue;
            });
            if (all && checked) {
                parent.children('input[type="checkbox"]').prop({
                    indeterminate: false,
                    checked: checked
                });
                checkSiblings(parent);
            } else if (all && !checked) {
                parent.children('input[type="checkbox"]').prop("checked", checked);
                parent.children('input[type="checkbox"]').prop("indeterminate", (parent.find('input[type="checkbox"]:checked').length > 0));
                checkSiblings(parent);
            } else {
                el.parents("li").children('input[type="checkbox"]').prop({
                    indeterminate: true,
                    checked: false
                });
            }
        }

        checkSiblings(container);
    });
});
